/* tslint:disable */
/* eslint-disable */
/**
 * api-docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const Operator = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Empty: 'EMPTY',
    NotEmpty: 'NOT_EMPTY',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    LessThan: 'LESS_THAN',
    LessThanOrEqual: 'LESS_THAN_OR_EQUAL',
    GreaterThan: 'GREATER_THAN',
    GreaterThanOrEqual: 'GREATER_THAN_OR_EQUAL',
    Duplicity: 'DUPLICITY',
};
export function OperatorFromJSON(json) {
    return OperatorFromJSONTyped(json, false);
}
export function OperatorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function OperatorToJSON(value) {
    return value;
}
//# sourceMappingURL=Operator.js.map